module.exports = __webpack_public_path__ + "static/media/ChannelSong.Assames.5d121c9f.jpg";